import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../../models/api-response.model';
import { CustomerModel } from '../../../../models/customer.model';
import { IncentiveDetails } from '../../../../models/incentive-details.model';
import { CommonService } from '../../../common/common.service';
import { SettingsService } from '../../../common/settings.service';
import { CommonSharedModule } from '../../../common/shared.module';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';

@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class CustomerDetailsComponent implements OnInit {
  @Input() incentiveDetails!: IncentiveDetails;
  @Output() refreshPartnerInput = new EventEmitter<void>();
  customers!: CustomerModel[];
  addCustomer!: CustomerModel;
  formCustomer!: FormGroup;
  apires!: ApiResponse;
  custmsgs!: any[];
  isReadonlycust = true;
  custbtnNav = false;
  isReadonlyUsage = true;
  msgs!: any[];
  isReadonly = true;
  incentiveId!: number;
  uname!: string;
  customerCountry!: string;

  constructor(
    private formBuilder: FormBuilder,
    private osmEdit: OsmosisEditService,
    private settingsServices: SettingsService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.formCustomer = this.formBuilder.group({
      tPID: [''],
      pmotPID: [''],
      tPName: [''],
      pmotPName: [''],
      customerTPIDListbasedonTenantID: [''],
      segmentGroup: [''],
      pmocustomerArea: [''],
      pmocustomerCountry: [''],
      pmousageArea: [''],
      pmousageCountry: [''],
      tenantID: [''],
      pmotenantID: [''],
      tanantName: [''],
      pmotanantName: [''],
      tenantListbasedonTPID: ['']
    });

    this.incentiveId = this.incentiveDetails.requestDetailId || -1;
    this.loadCustomerDetails();
  }

  loadCustomerDetails() {
    this.formCustomer.patchValue({
      tPID: this.incentiveDetails.partnerInputCustomerTPID,
      tPName: this.incentiveDetails.partnerInputCustomerName,
      customerTPIDListbasedonTenantID: this.incentiveDetails.customerTPIDList,
      segmentGroup: this.incentiveDetails.segmentGroup,
      customerArea: this.incentiveDetails.customerLocation,
      customerCountry: this.incentiveDetails.partnerInputCustomerCountry,
      usageArea: this.incentiveDetails.usageAreaPartnerEnteredisEmpty,
      usageCountry: this.incentiveDetails.usageCountryPartnerEnteredisEmpty,
      tenantID: this.incentiveDetails.partnerInputTenantID,
      tanantName: this.incentiveDetails.partnerInputTenantName,
      tenantListbasedonTPID: this.incentiveDetails.tenantListbasedonTPID,
      pmotPID: this.incentiveDetails.pmoConfirmedCustomerTPID,
      pmocustomerArea: this.incentiveDetails.pmoConfirmedTopParentCustomerArea,
      pmocustomerCountry:
        this.incentiveDetails.pmoConfirmedTopParentCustomerCountry,
      pmousageArea: this.incentiveDetails.pmoConfirmedUsageArea,
      pmousageCountry: this.incentiveDetails.pmoConfirmedUsageCountry,
      pmotenantID: this.incentiveDetails.pmoConfirmedTenantId,
      pmotanantName: this.incentiveDetails.pmoConfirmedTenantName,
      pmotPName: this.incentiveDetails.pmoconfimedTopParentCustomerName
    });
    this.customerCountry =
      this.incentiveDetails.pmoConfirmedTopParentCustomerCountry || '';
  }

  editCustomerCancel() {
    this.isReadonlycust = true;
    this.custmsgs = [];
    this.custbtnNav = false;
    this.loadCustomerDetails();
  }

  editCustomer() {
    this.isReadonlycust = false;
    this.custmsgs = [];
    this.custbtnNav = true;
  }

  get release(): string {
    return environment.isProdEnvironment ? 'Prod' : 'Dev';
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onSubmitCustomer() {
    this.uname = this.settingsServices.AliasName || '';

    this.addCustomer = {
      requestDetailId: this.incentiveId,
      partnerInputCustomerTpid: this.formCustomer.controls['tPID'].value,
      pmoconfirmedCustomerTpid: this.formCustomer.controls['pmotPID'].value,
      partnerInputTenantName: this.formCustomer.controls['tPName'].value,
      pmoconfimedTopParentCustomerName:
        this.formCustomer.controls['pmotPName'].value,
      customerTpidlist:
        this.formCustomer.controls['customerTPIDListbasedonTenantID'].value,
      segmentGroup: this.formCustomer.controls['segmentGroup'].value,
      pmoconfirmedTopParentCustomerArea:
        this.formCustomer.controls['pmocustomerArea'].value,
      pmoconfirmedTopParentCustomerCountry:
        this.formCustomer.controls['pmocustomerCountry'].value,
      pmoconfirmedUsageArea: this.formCustomer.controls['pmousageArea'].value,
      pmoconfirmedUsageCountry:
        this.formCustomer.controls['pmousageCountry'].value,
      partnerInputTenantId: this.formCustomer.controls['tenantID'].value,
      pmoconfirmedTenantId: this.formCustomer.controls['pmotenantID'].value,
      partnerInputCustomerName: this.formCustomer.controls['tanantName'].value,
      pmoconfirmedTenantName: this.formCustomer.controls['pmotanantName'].value,
      partnerInputDomainName: this.incentiveDetails.partnerInputDomainName,
      pmoconfirmedDomainName: this.incentiveDetails.pmoConfirmedDomainName,
      tenantListbasedonTpid:
        this.formCustomer.controls['tenantListbasedonTPID'].value,
      lastUserAlias:
        this.uname !== '' && this.uname !== '' && this.uname != null
          ? this.uname
          : ''
    };

    this.osmEdit.addCustomer(this.addCustomer).subscribe(
      messageResponse => {
        this.apires = messageResponse;
        if (this.apires.success === true) {
          this.refreshPartnerInput.emit();
          this.custmsgs = [];
          this.custmsgs.push({
            severity: 'success',
            detail: 'Records Saved Successfully.'
          });
        }
        if (this.apires.success === false) {
          this.custmsgs = [];
          this.custmsgs.push({
            severity: 'error',
            detail: this.apires.errorMessages
              ? this.apires.errorMessages[0]
              : 'Unknown error'
          });
          this.isReadonlycust = true;
          this.custbtnNav = false;
        }
      },
      error => {
        this.custmsgs = [];
        let errors: string[] = [];
        if (error.status === 400) {
          errors = this.commonService.getBadRequestErrors(error);
          for (const msg of errors) {
            this.custmsgs.push({ severity: 'warn', detail: msg });
          }
        } else {
          this.custmsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Adding Partner Details'
          });
        }
      }
    );
  }
}
